import React from 'react';
import ImagePlaceholder from '../components/ImagePlaceholder';
import PlaygroundHero from '../../../assets/landing/playground-hero.png';
import '../LandingPage.css';

const PlaygroundSection = () => {
    return (
        <section className="lp-section lp-playground">
            <div className="lp-section-header fade-in-section">
                <h2 className="lp-section-label">The Playground</h2>
                <h3 className="lp-section-title">Your Creative Sandbox.</h3>
                <p className="lp-section-desc">
                    Experiment freely. Generate and save images, videos, and audio with the model you choose.
                    Test your ideas, prompts, and styles. Keep what works. Discard what doesn’t—without touching your main projects.
                </p>
            </div>

            <div className="lp-playground-visual fade-in-section">
                <div className="lp-app-frame">
                    <img
                        src={PlaygroundHero}
                        alt="Playground Interface"
                        className="lp-dashboard-img active"
                    />
                </div>
            </div>
        </section>
    );
};

export default PlaygroundSection;
